var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5646 2.78414L0.985975 12.9841C-0.0835843 13.459 -0.445347 14.4103 0.727416 14.9265L7.54603 17.0829L24.0324 6.94318C24.9326 6.3066 25.8541 6.47636 25.0612 7.17659L10.9016 19.9353L10.4567 25.3348C10.8687 26.1685 11.6231 26.1723 12.1042 25.758L16.0217 22.0691L22.731 27.0689C24.2893 27.987 25.1372 27.3945 25.4724 25.7118L29.8731 4.97452C30.3301 2.90318 29.5508 1.99055 27.5646 2.78414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.72438515d245ea2a01c9992418c5034a.svg";
export { ForwardRef as ReactComponent };